import React from 'react';
import { useDashboard } from '../context/DashboardContext';
import { EventAction, Severity } from '../types';
import './FilterBar.css';

export const FilterBar: React.FC = () => {
  const { filters, updateFilter, resetFilters } = useDashboard();

  const eventTypes: (EventAction | 'all')[] = [
    'all',
    'REQUEST',
    'LOGIN_ATTEMPT',
    'TRAP_SPAWNED',
    'REROUTE',
    'COMMAND_EXECUTED',
    'SUSPICIOUS_BEHAVIOR',
    'FILE_ACCESS',
    'DATA_EXFILTRATION',
  ];

  const severities: (Severity | 'all')[] = ['all', 'low', 'medium', 'high'];

  return (
    <div className="filter-bar">
      <div className="filter-group">
        <label className="filter-label">Severity</label>
        <select
          className="filter-select"
          value={filters.severity}
          onChange={(e) => updateFilter('severity', e.target.value)}
        >
          {severities.map((sev) => (
            <option key={sev} value={sev}>
              {sev.toUpperCase()}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label className="filter-label">Event Type</label>
        <select
          className="filter-select"
          value={filters.eventType}
          onChange={(e) => updateFilter('eventType', e.target.value)}
        >
          {eventTypes.map((type) => (
            <option key={type} value={type}>
              {type.replace(/_/g, ' ')}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group filter-group--search">
        <label className="filter-label">Search (IP or Path)</label>
        <input
          type="text"
          className="filter-input"
          placeholder="192.168.1.1 or /admin"
          value={filters.searchText}
          onChange={(e) => updateFilter('searchText', e.target.value)}
        />
      </div>

      {filters.selectedSessionId && (
        <div className="filter-active">
          <span className="filter-active__label">
            Filtered by session: <strong>{filters.selectedSessionId}</strong>
          </span>
          <button
            className="filter-clear-btn"
            onClick={() => updateFilter('selectedSessionId', null)}
          >
            ✕
          </button>
        </div>
      )}

      <button className="filter-reset-btn" onClick={resetFilters}>
        Reset Filters
      </button>
    </div>
  );
};
